(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('ringfoonAgendaList', ['$compile', 'SharedAgendaService', 'AgendaTransitionService', 'SharedAgendaBroadcast', RingfoonAgendasListDirectiveFn]);

    /* directive for shared agendas dropdown in header */
    function RingfoonAgendasListDirectiveFn($compile, SharedAgendaService, AgendaTransitionService, SharedAgendaBroadcast) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/ringfoon/templates/ringfoon-agendas-list.template.html'
        };
        return directive;

        function link(scope, element) {
            // agendas to display
            scope.service = SharedAgendaService.data;
            
            scope.currentUserIsRingphoneAdmin = () => SharedAgendaService.currentUserIsRingphoneAdmin();

            ////  main button 
            //var elMain = element.find("#main");

            activate();

            // activate
            function activate() {
                // current selected shared-agenda
                scope.current = SharedAgendaService.data.currentAgenda;

                //listen();

                //image();
            }


            //// listen
            //function listen() {

            //    // listen on changed client
            //    var listener = scope.$on(SharedAgendaBroadcast.AgendaOwnerLoaded, function () {
            //        updateUI(SharedAgendaService.data.currentAgenda);
            //    });

            //    var lUi = scope.$on(SharedAgendaBroadcast.UpdateUI, function () {
            //        updateUI(SharedAgendaService.data.currentAgenda);
            //    });

            //    // on destroy
            //    scope.$on("$destroy", function () {
            //        listener();
            //        lUi();
            //        listener = null;
            //        lUi = null;
            //    });
            //}

            // select
            function select(agenda) {
                // is user allowed to change/select another user ?
                if (scope.service.selectable === false) {
                    return;
                } // if

                // if still selected -> do nothing
                if (agenda.selected === true) {
                    return;
                } //if

                // select new agenda 
                AgendaTransitionService.select(agenda);

                // update ui
                // if (scope.current.id !== agenda.id) { updateUI(agenda); }

            }

            // update ui
            //function updateUI(agenda) {
            //    scope.current = agenda;

            //    // set image
            //    //image();
            //}

            //// change image
            //function image() {
            //    // change user-image
            //    elMain.find("img").remove();
            //    var el = '<user-image user-id="current.owner.id" thumb-width="25" thumb-height="25" class="img-circle" add-query="true"></user-image>';
            //    elMain.append($compile(el)(scope));
            //}


            ///* select user */
            scope.select = select;

        }
    }

})();